<template>
  <div class="theme-container">
    <div class="container">
      <div class="theme">
        <span v-if="option.eventName" contenteditable="true" @input="updateText" v-class="option[1]">{{ option.eventName }}</span>
        <span v-if="option.location" contenteditable="true">{{ option.location }}</span>
        <span v-if="option.date" contenteditable="true">{{ option.date }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Theme', 
  props: ['option'],
  newOption: {
    'eventName': '',
    'location': '',
    'date': ''
  },
  // mounted:function(){
  //   this.$el.innerText = this.content;
  // },
  methods:{
    updateText:function(event){
      const text = event.target.innerText
     // this.$emit('updateText', event.target.innerText)
      console.log(text)
      // userTheme = this.state.newEventName = text 
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../static/themes/purple-maze/style.scss';

.theme-container {
  margin: 25px auto;
}

*[contenteditable=true] {
  &:hover {
    background-color: #efefef;
    box-shadow: 0px 0px 2px rgba(85, 153, 255, 0.8);
    border-radius: 4px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Theme.vue